import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TenantData } from '../shared/tenant-data';
import { ContactData } from '../shared/contact-data';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class RestApiService {
	// Define API
 	//applicationURL = 'https://ilmswebstag.interlaceindia.com:4000';//ILMS PROD APPLICATION URL
	apiURL           = 'https://ilms.interlaceindia.com:7000';//ILMS API URL
	//apiURL         = 'http://192.168.12.186:4000';//PROD APPLICATION URL
	//PapiURL        = 'https://ilmswebstag.interlaceindia.com:7001';//Pharma ERP API URL
	//PapplicationURL= 'https://ilmswebstag.interlaceindia.com:7000';//Pharma ERP APPLICATION URL 
	
	constructor(private http: HttpClient) { }
	
	// Http Options
	httpOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json',
			//'Access-Control-Allow-Origin': '*'
		})
	}
	
	// HttpClient API post() method => Create Tenant
	// ILMS PRODUCT 
	createTenant(tenant : any): Observable<TenantData> {
		return this.http.post<TenantData>(this.apiURL + '/tenantlist/', JSON.stringify(tenant), this.httpOptions)
		.pipe(
			retry(1),
			catchError(this.handleError)
		)
	}
	
	sendMail(tenant : any): Observable<TenantData> {
		return this.http.post<TenantData>(this.apiURL + '/sendmailsRegistration/', JSON.stringify(tenant), this.httpOptions)
		.pipe(
			retry(1),
			catchError(this.handleError)
		)
	}
	
	// HttpClient API post() method => Create Tenant
	/* createContact(contact : any): Observable<ContactData> {
		return this.http.post<ContactData>(this.apiURL + '/contactlist/', JSON.stringify(contact), this.httpOptions)
		.pipe(
			retry(1),
			catchError(this.handleError)
		)
	} */
	
	verifyCaptcha(contact : any): Observable<ContactData> {
		return this.http.post<ContactData>(this.apiURL + '/checkCaptcha/', JSON.stringify(contact), this.httpOptions)
		.pipe(
			retry(1),
			catchError(this.handleError)
		)
	}
	
	/* sendContactMail(contact : any): Observable<ContactData> {
		return this.http.post<ContactData>(this.apiURL + '/sendmailsContact/', JSON.stringify(contact), this.httpOptions)
		.pipe(
			retry(1),
			catchError(this.handleError)
		)
	}
	 */
	sendEmailOTP(tenant : any): Observable<TenantData> {
		return this.http.post<TenantData>(this.apiURL + '/sendEmailOTP/', JSON.stringify(tenant), this.httpOptions)
		.pipe(
			retry(1),
			catchError(this.handleError)
		)
	}
	
	verifyEmailOTP(tenant : any): Observable<TenantData> {
		return this.http.post<TenantData>(this.apiURL + '/verifyEmailOTP/', JSON.stringify(tenant), this.httpOptions)
		.pipe(
			retry(1),
			catchError(this.handleError)
		)
	}
	
	syncTenantData(tenant : any): Observable<TenantData> {
		return this.http.post<TenantData>(this.apiURL + '/syncTenantData/', JSON.stringify(tenant), this.httpOptions)
		.pipe(
			retry(1),
			catchError(this.handleError)
		)
	}
	
/* 	checkCaptcha(data : any): Observable<any> {
		//return this.http.post<any>(this.apiURL + '/checkCaptcha/', JSON.stringify(data), this.httpOptions)
		return this.http.post<any>('http://interlaceindia.com/botdetect-captcha-lib/contact.php', JSON.stringify(data), this.httpOptions)
		.pipe(
			retry(1),
			catchError(this.handleError)
		)
	} */
	
	public getPackages(){
		return this.http.get(this.apiURL + '/packagelist/?format=json', this.httpOptions)
		.pipe(
			retry(1),
			catchError(this.handleError)
		)
	}
	/*
	// Pharma ERP 
	public getPPackages(){
		return this.http.get(this.PapiURL + '/packagelist/?format=json', this.httpOptions)
		.pipe(
			retry(1),
			catchError(this.handleError)
		)
	}
	
	PcreateTenant(tenant : any): Observable<TenantData> {
		return this.http.post<TenantData>(this.PapiURL + '/tenantlist/', JSON.stringify(tenant), this.httpOptions)
		.pipe(
			retry(1),
			catchError(this.handleError)
		)
	}
	
	PsendMail(tenant : any): Observable<TenantData> {
		return this.http.post<TenantData>(this.PapiURL + '/sendmailsRegistration/', JSON.stringify(tenant), this.httpOptions)
		.pipe(
			retry(1),
			catchError(this.handleError)
		)
	}
	
	
	PverifyCaptcha(contact : any): Observable<ContactData> {
		return this.http.post<ContactData>(this.PapiURL + '/checkCaptcha/', JSON.stringify(contact), this.httpOptions)
		.pipe(
			retry(1),
			catchError(this.handleError)
		)
	}
	
	PsendEmailOTP(tenant : any): Observable<TenantData> {
		return this.http.post<TenantData>(this.PapiURL + '/sendEmailOTP/', JSON.stringify(tenant), this.httpOptions)
		.pipe(
			retry(1),
			catchError(this.handleError)
		)
	}
	
	PverifyEmailOTP(tenant : any): Observable<TenantData> {
		return this.http.post<TenantData>(this.PapiURL + '/verifyEmailOTP/', JSON.stringify(tenant), this.httpOptions)
		.pipe(
			retry(1),
			catchError(this.handleError)
		)
	}
	
	PsyncTenantData(tenant : any): Observable<TenantData> {
		return this.http.post<TenantData>(this.PapplicationURL + '/syncTenantData/', JSON.stringify(tenant), this.httpOptions)
		.pipe(
			retry(1),
			catchError(this.handleError)
		)
	}
	*/
	
	// Error handling 
	handleError(error : any) {
		let errorMessage = '';
		if(error.error instanceof ErrorEvent) {
			// Get client-side error
			errorMessage = error.error.message;
		} else {
			// Get server-side error
			errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
		}
		window.alert(errorMessage);
		return throwError(errorMessage);
	}

}
